/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Grid } from "@material-ui/core";
import backWave from "../../../assets/image/backWave.svg";
import backWave3 from "../../../assets/image/backWave3.svg";
import useStyles from "../../../styles";
import menuIcon from "../../../assets/icon/Group 298.svg";
import history from "../../../utilize/history";
import { useDispatch, useSelector } from "react-redux";
import DrawerMenu from "./DrawerMenu";
import { useEffect, useState } from "react";
import { getProfileDetail } from "../../../routes/actions";
import HeaderBackground from "./HeaderBackground";
import { useLocation } from "react-router";
import searchIcon from "assets/icon/Search.svg";
import SearchDialog from "./SearchDialog";

export default function MobHeader() {
  const classes = useStyles();
  const { isLogin } = useSelector((state) => state.main);
  const tour = useSelector((state) => state?.main?.tour);
  const [open, setOpen] = useState(false);
  const [openSearchDialog, setOpenSearchDialog] = useState(false);
  const location = useLocation();
  const handleOpenDrawer = () => {
    setOpen(true);
  };

  const handleCloseDrawer = () => {
    setOpen(false);
  };

  const handleOpenSearchModal = () => {
    setOpenSearchDialog(true);
  };

  const handleCloseSearchDialog = () => {
    setOpenSearchDialog(false);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem("aghighToken")?.length > 4 && isLogin) {
      dispatch(getProfileDetail(localStorage.getItem("aghighToken")));
    }
  }, []);

  return (
    <>
      {!tour?.run && (
        <Grid container style={{ position: "relative" }}>
          <img
            src={location.pathname !== "/" ? backWave3 : backWave}
            alt="backWave"
            style={{ width: "100%" }}
          />
          <Grid
            container
            className={classes.mobHeaderInsideContainer}
            style={{ zIndex: 23 }}
          >
            <Grid container alignItems="center" justify="space-between">
              {isLogin ? (
                <img
                  src={menuIcon}
                  alt="menu"
                  style={{ marginTop: 25, marginRight: 20, zIndex: 21 }}
                  onClick={handleOpenDrawer}
                />
              ) : (
                <Grid item />
              )}

              <Grid item className={classes.loginSignUpContainer}>
                {isLogin ? (
                  <img
                    src={searchIcon}
                    alt="search"
                    style={{ width: 25, marginTop: 10 }}
                    onClick={handleOpenSearchModal}
                  />
                ) : (
                  <>
                    <Button
                      variant="text"
                      className={`${classes.fontSize12} ${classes.loginButton}`}
                      onClick={() => history.push("/")}
                    >
                      خانه
                    </Button>
                    <Grid item className={classes.verticalLineLoginSignUp} />

                    {/* <Button
                      variant="text"
                      className={classes.mobLoginButton}
                      onClick={() => history.push("/enghelab/school")}
                    >
                      مدرسه انقلاب
                    </Button> */} 
                    {/* <Button
                      variant="text"
                      className={classes.mobLoginButton}
                      onClick={() => history.push("/talayedaran")}
                    >
                       ثبت نام طلایه داران
                    </Button> */}
                    <Grid item className={classes.verticalLineLoginSignUp} />

                    <Button
                      variant="outlined"
                      className={classes.mobLoginButton}
                      onClick={() => history.push("/login")}
                    >
                      ورود
                    </Button>
                    <Grid item className={classes.verticalLineLoginSignUp} />
                    <Button
                      variant="contained"
                      className={classes.mobSignUpButton}
                      onClick={() => history.push("/signup")}
                    >
                      ثبت‌نام
                    </Button>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
          <HeaderBackground />
          <DrawerMenu open={open} handleClose={handleCloseDrawer} />
          <SearchDialog
            open={openSearchDialog}
            handleClose={handleCloseSearchDialog}
          />
        </Grid>
      )}
    </>
  );
}
